export function limitWords(context, wordCount) {
  if (!context) return '';

  const words = context.trim().split(/\s+/);

  if (words.length <= wordCount) {
    return context;
  }

  return words.slice(0, wordCount).join(' ') + '...';
}